
// export const imagepaths = process.env.PUBLIC_URL + {
//     Applogo : '/assets/img/logo2.png'
// }

// export default imagepaths

export const Infologo = process.env.PUBLIC_URL + '/assets/img/infoc.png';
export const headerlogo = process.env.PUBLIC_URL + '/assets/img/logo.png';
export const Applogo = process.env.PUBLIC_URL + '/assets/img/logo2.png';
export const logo3 = process.env.PUBLIC_URL + '/assets/img/logo3.png';
export const lnEnglish = process.env.PUBLIC_URL + '/assets/img/flags/us.png';
export const lnFrench = process.env.PUBLIC_URL + '/assets/img/flags/fr.png';
export const lnSpanish = process.env.PUBLIC_URL + '/assets/img/flags/es.png';
export const lnGerman = process.env.PUBLIC_URL + '/assets/img/flags/de.png';
export const Avatar_01 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-01.jpg';
export const Avatar_02 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-02.jpg';
export const Avatar_03 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-03.jpg';
export const Avatar_04 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-04.jpg';
export const Avatar_05 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-05.jpg';
export const Avatar_06 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-06.jpg';
export const Avatar_07 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-07.jpg';
export const Avatar_08 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-08.jpg';
export const Avatar_09 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-09.jpg';
export const Avatar_10 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-10.jpg';
export const Avatar_11 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-11.jpg';
export const Avatar_12 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-12.jpg';
export const Avatar_13 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-13.jpg';
export const Avatar_14 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-14.jpg';
export const Avatar_15 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-15.jpg';
export const Avatar_16 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-16.jpg';
export const Avatar_17 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-17.jpg';
export const Avatar_18 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-18.jpg';
export const Avatar_19 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-19.jpg';
export const Avatar_20 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-20.jpg';
export const Avatar_21 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-21.jpg';
export const Avatar_22 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-22.jpg';
export const Avatar_24 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-24.jpg';
export const Avatar_25 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-25.jpg';
export const Avatar_26 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-26.jpg';
export const Avatar_28 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-28.jpg';
export const Avatar_29 = process.env.PUBLIC_URL + '/assets/img/profiles/avatar-29.jpg';
export const User = process.env.PUBLIC_URL + '/assets/img/user.jpg';
export const Img_01 = process.env.PUBLIC_URL + '/assets/img/img-01.jpg';
export const PlaceHolder = process.env.PUBLIC_URL + '/assets/img/placeholder.jpg';
export const Attachment = process.env.PUBLIC_URL + '/assets/img/attachment.png';
export const Video_Call = process.env.PUBLIC_URL + '/assets/img/video-call.jpg';